import axios from 'axios';

// 按钮权限
export function getBtns(data) {
  return axios.get('platform/v1/resources/granted/button?', { params: data })
}

//  获取数据字典
export function getDic(data) {
  return axios.get('product/v1/middle/product/init?', {params: data})
}



// WEBPACK FOOTER //
// ./src/interface.js